import React, { useEffect, useState } from 'react';
import { PAGES } from '../../site/routes';
import { fetchArticles } from '../../site/articlesApi';
import ArticleCard from '../../site/ArticleCard';
import CoinLoader from '../../components/CoinLoader';
import { usePageSeo, Breadcrumbs, PageHeader, Section, LinkCards, CtaBand } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Articles', to: PAGES.articles },
];

export default function ArticlesPage() {
  const [articles, setArticles] = useState(null);
  const [error, setError] = useState('');
  const [category, setCategory] = useState('Tous');

  useEffect(() => {
    fetchArticles().then(setArticles).catch(() => setError('Impossible de charger les articles pour le moment.'));
  }, []);

  usePageSeo({
    title: 'Articles Dofus et Kamas : guides et conseils | AV Kamas',
    description: "Guides et conseils sur Dofus au Maroc : acheter et vendre des Kamas en sécurité, choisir son serveur Dofus 3, Rétro ou Touch, éviter les arnaques.",
    path: PAGES.articles,
    breadcrumbs: BREADCRUMBS,
  });

  const categories = ['Tous', ...new Set((articles || []).map(a => a.category))];
  const visible = (articles || []).filter(a => category === 'Tous' || a.category === category);

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Le blog AV Kamas"
        title={<>Articles Dofus et <span className="text-yellow-400">Kamas</span></>}
        intro="Guides pratiques, choix de serveur et conseils de sécurité pour acheter et vendre vos Kamas au Maroc."
      >
        {categories.length > 2 && (
          <div className="flex gap-2 mt-4 overflow-x-auto [scrollbar-width:none]" role="tablist" aria-label="Catégories">
            {categories.map(c => (
              <button
                key={c}
                role="tab"
                aria-selected={category === c}
                onClick={() => setCategory(c)}
                className={`px-3 py-1.5 rounded-lg text-xs sm:text-sm whitespace-nowrap border ${category === c ? 'bg-yellow-500 text-black border-yellow-500 font-semibold' : 'bg-gray-900 text-gray-300 border-gray-800 hover:border-yellow-500/50'}`}
              >
                {c}
              </button>
            ))}
          </div>
        )}
      </PageHeader>

      <Section className="pt-0 md:pt-0">
        {error && <p className="text-red-400">{error}</p>}
        {!articles && !error && <CoinLoader label="Chargement des articles…" />}
        {articles && visible.length === 0 && <p className="text-gray-400">Aucun article pour le moment.</p>}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {visible.map(article => <ArticleCard key={article.id} article={article} />)}
        </div>
      </Section>

      <Section title="Nos guides" className="bg-gray-900/40">
        <LinkCards
          links={[
            { to: PAGES.buyGuide, title: 'Achat Kamas Maroc', text: 'Acheter vos Kamas en dirhams, étape par étape.' },
            { to: PAGES.sellGuide, title: 'Vente Kamas Maroc', text: 'Vendre vos Kamas et être payé par virement.' },
            { to: PAGES.servers, title: 'Serveurs Dofus', text: 'Les 20 serveurs officiels et le prix de leurs Kamas.' },
          ]}
        />
      </Section>
      <CtaBand />
    </main>
  );
}
